import moment from "moment";
import VMasker from "vanilla-masker";
import nanoajax from "nanoajax";
import { test } from "ramda";
import {
	checkValidityError,
	validateStringTwoWords,
	setAsInvalid,
	setAsValid
} from "../shared/validation-utils";
import mapKeys from "lodash/mapKeys";
import { companyFields, personFields } from "./fields";
import { $, requestSuccess, extractValues, checkEmptyValue } from "../vanilla/utils";

export const checkInputOnLength = event => {
	if (typeof event !== "undefined") {
		const name = event.target.name;
		const value = event.target.value;
		let isValid = true;

		if (name === "cpf" && value.length >= 14) {
			checkValidityError(event);
		}

		if (name === "cnpj" && value.length >= 18) {
			checkValidityError(event);
		}

		if (name === "phone1" && value.replace(/\D/g, "").length >= 10) {
			checkValidityError(event);
		}

		if (name === "register_name" && value.length >= 0) {
			checkValidityError(event);

			let isValidWithSurname = validateStringTwoWords(value);
			let isValidWithChars = test(/^[a-zA-ZÀ-ÿ\s]+/gim, value);

			isValid = isValidWithSurname && isValidWithChars;

			if (!isValid) {
				let msg = !isValidWithChars ? "Campo inválido" : "Obrigatório informar sobrenome.";

				setAsInvalid(event.target, msg);
				event.target.setAttribute("hasBusinessError", "true");
			} else {
				setAsValid(event.target);
				event.target.removeAttribute("hasBusinessError");
			}
		}

		if (name === "register_birth" && value.length >= 10) {
			isValid =
				verifyUserBirthday(value).is18 &&
				verifyUserBirthday(value).isLimitAge &&
				verifyUserBirthday(value).isValidDate;
			const is18 = verifyUserBirthday(value).is18;
			const isValidDate = verifyUserBirthday(value).isValidDate;
			const isLimitAge = verifyUserBirthday(value).isLimitAge;

			if (!isValid) {
				let msg = !isValidDate
					? "Data de nascimento deve ser no formato dd/mm/aaaa"
					: !isLimitAge
						? "Você deve ter menos de 120 anos de idade"
						: !is18 ? "Você deve ter mais de 18 anos de idade" : "";

				setAsInvalid(event.target, msg);
				event.target.setAttribute("hasBusinessError", "true");
			} else {
				setAsValid(event.target);
				event.target.removeAttribute("hasBusinessError");
			}
		} else if (name === "register_birth" && value.length === 0) {
			let msg = "Obrigatório informar data de nascimento.";
			event.target.setAttribute("hasBusinessError", "true");
			setAsInvalid(event.target, msg);
		}
	}
};

export const verifyUserBirthday = dateEntered => {
	const dateFormat = "DD/MM/YYYY";
	const is18 = moment(convertMaskedDate(dateEntered)).isBefore(moment().subtract(18, "years"));
	const isValidDate = moment(dateEntered, dateFormat, true).isValid();
	const isLimitAge = moment(convertMaskedDate(dateEntered)).isAfter(
		moment().subtract(120, "years")
	);

	return { is18, isValidDate, isLimitAge };
};

export const convertMaskedDate = value => {
	if (checkEmptyValue(value)) {
		return "";
	}
	return value
		.split("/")
		.reverse()
		.join("-");
};

export const serchingSSN = (searching, type) => {
	if (type === "j") {
		if (searching) {
			$("#cnpj_loader").style.display = "block";
			$("#cnpj").disabled = true;
		} else {
			$("#cnpj_loader").style.display = "none";
			$("#cnpj").disabled = false;
		}
	} else {
		if (searching) {
			$("#cpf_loader").style.display = "block";
			$("#cpf").disabled = true;
		} else {
			$("#cpf_loader").style.display = "none";
			$("#cpf").disabled = false;
		}
	}
};

export const checkSsnExists = event => {
	const input = event.target;
	const name = event.target.name.toUpperCase();

	if (!$("#cpf").disabled && !$("#cnpj").disabled) {
		const type = $("#type_person").checked ? "f" : "j";
		serchingSSN(true, type);

		nanoajax.ajax(
			{
				url: `/check-ssn`,
				method: "POST",
				body: JSON.stringify({ type, ssn: input.value }),
				checkValidityError
			},
			(code, responseJSON) => {
				serchingSSN(false, type);

				if (requestSuccess(code)) {
					const response = JSON.parse(responseJSON);
					if (response.exists) {
						setAsInvalid(input, `${name} já cadastrado`);
						input.setAttribute("hasBusinessError", "true");
					} else {
						setAsValid(input);
						input.removeAttribute("hasBusinessError");
					}
				} else {
					if (code === 400) {
						setAsInvalid(input, `${name} inválido/inexistente`);
						input.setAttribute("hasBusinessError", "true");
					}
				}
			}
		);
	}
};

/**
 * verifica se o input HTML é válido
 * @param {HTMLElement} element
 */
export const checkValidityErrorHTML = element => {
	let obj = {
		target: element
	};
	checkValidityError(obj);
};

const loadingCheckEmail = loading => {
	if (loading) {
		$("#email_loader").style.display = "block";
	} else {
		$("#email_loader").style.display = "none";
	}
};

export const checkEmailExists = event => {
	const input = event.target;

	if (checkEmptyValue(event.target.value)) {
		return;
	}

	loadingCheckEmail(true);
	nanoajax.ajax(
		{
			url: `/check-email`,
			method: "POST",
			body: JSON.stringify({ email: input.value }),
			headers: { "Content-Type": "application/json" }
		},
		(code, responseJSON) => {
			try {
				if (requestSuccess(code)) {
					const response = JSON.parse(responseJSON);
					if (response.exists) {
						setAsInvalid(input, "Email já cadastrado");
						input.setAttribute("hasBusinessError", "true");
					} else {
						setAsValid(input);
						input.removeAttribute("hasBusinessError");
					}
				} else {
					if (code === 400) {
						setAsInvalid(input, "Email inválido");
						input.setAttribute("hasBusinessError", "true");
					}
				}
				loadingCheckEmail(false);
			} catch (error) {
				loadingCheckEmail(false);
			}
		}
	);
};

const loadingCheckLogin = loading => {
	if (loading) {
		$("#login_loader").style.display = "block";
	} else {
		$("#login_loader").style.display = "none";
	}
};

export const checkLoginExists = event => {
	const input = event.target;
	const value = event.target.value;

	if (checkEmptyValue(value)) {
		return;
	}

	if (value.length < 3) {
		setAsInvalid(input, "Seu login deve conter no mínimo 3 caracteres");
		input.setAttribute("hasBusinessError", "true");
		return;
	}

	if (!value.match(/[a-z]/i)) {
		setAsInvalid(input, "Login deve conter pelo menos uma letra");
		input.setAttribute("hasBusinessError", "true");
		return;
	}

	loadingCheckLogin(true);

	nanoajax.ajax(
		{
			url: `/check-login`,
			method: "POST",
			body: JSON.stringify({ login: value }),
			headers: { "Content-Type": "application/json" }
		},
		(code, responseJSON) => {
			try {
				if (requestSuccess(code)) {
					const response = JSON.parse(responseJSON);
					if (response.exists) {
						setAsInvalid(input, "Esse login já está cadastrado");
						input.setAttribute("hasBusinessError", "true");
					} else {
						setAsValid(input);
						input.removeAttribute("hasBusinessError");
					}
				} else {
					if (code === 400) {
						setAsInvalid(input, "Login inválido");
						input.setAttribute("hasBusinessError", "true");
					}

				}
				loadingCheckLogin(false);
			} catch (error) {
				loadingCheckLogin(false);
			}
		}
	);
};

export const checkEmailConfirmation = event => {
	const value = event.target.value;
	if (value !== $("#email").value) {
		setAsInvalid(event.target, "Email diferente");
		event.target.setAttribute("hasBusinessError", "true");
	} else {
		setAsValid(event.target);
		event.target.removeAttribute("hasBusinessError");
	}
};

export const changeRequiredAttribute = (element, passed) => {
	if (passed) {
		element.classList.toggle("icon-check", true);
		element.classList.toggle("icon-close", false);
	} else {
		element.classList.toggle("icon-check", false);
		element.classList.toggle("icon-close", true);
	}
};

export const changeAllPassed = passed => {
	if (passed) {
		$("#password_rules").classList.toggle("passed", true);
		$("#password_title").classList.toggle("passed", true);
	} else {
		$("#password_rules").classList.toggle("passed", false);
		$("#password_title").classList.toggle("passed", false);
	}
};

export const checkPasswordRequirements = event => {
	let digits, letterAndNumber, differentFromLogin, allPassed;
	const value = event.target.value;

	digits = value.length >= 8;
	letterAndNumber = value.match(/^(?=.*\d)(?=.*[a-zA-Z]).+$/) !== null;
	allPassed = digits && letterAndNumber ? "passed" : "";

	if (allPassed !== "passed") {
		setAsInvalid(event.target, "Senha fora dos requisitos");
		event.target.setAttribute("hasBusinessError", "true");
	} else {
		setAsValid(event.target);
		event.target.removeAttribute("hasBusinessError");
	}

	if (digits) {
		changeRequiredAttribute($("#password_mindig"), true);
	} else {
		changeRequiredAttribute($("#password_mindig"), false);
	}

	if (letterAndNumber) {
		changeRequiredAttribute($("#password_numblet"), true);
	} else {
		changeRequiredAttribute($("#password_numblet"), false);
	}

	if (allPassed) {
		changeAllPassed(true);
	} else {
		changeAllPassed(false);
	}
};

export const showPasswordRules = flag => {
	if (flag) {
		$("#password_rules").style.display = "block";
	} else {
		$("#password_rules").style.display = "none";
	}
};

export const checkPasswordConfirmation = event => {
	const value = event.target.value;
	if (value !== $("#password").value) {
		setAsInvalid(event.target, "Senha diferente");
		event.target.setAttribute("hasBusinessError", "true");
	} else {
		setAsValid(event.target);
		event.target.removeAttribute("hasBusinessError");
	}
};

export const setFacebookDataToDOM = fb => {
	if (fb.data.name) {
		$("#register_name").value = fb.data.name;
	}
};

/**
 * Binda validadores ao formulário selecionado
 * @param $form
 */
export const observeValidators = $form => {
	if (!$form) {
		return;
	}

	if ($form.getAttribute("validation-set") == null) {
		$form.setAttribute("validation-set", "");
		extractValues($form.querySelectorAll("*:required")).map(domItem => {
			domItem.onblur = event => {
				event.target.setAttribute("data-touched", "");
				checkValidityError(event);
			};
		});
	}
};

export const handleTypeChange = event => {
	const termPf = $('#terms-pf');
	const termPj = $('#terms-pj');

	if (event.target.id === "type_person") {
		$("#person-form").style.display = "block";
		$("#company-form").style.display = "none";
		$("#pj_info").style.display = "none";
		termPj.style.display = "none";
		termPf.style.display = "block";

		setTimeout(() => {
			mapKeys(personFields, setFieldListeners);
			setInputsMask();
			setNotRequiredFields();
		}, 1);
	} else {
		$("#person-form").style.display = "none";
		$("#company-form").style.display = "block";
		$("#pj_info").style.display = "block";
		termPf.style.display = "none";
		termPj.style.display = "block";

		setTimeout(() => {
			mapKeys(companyFields, setFieldListeners);
			setInputsMask();
			setNotRequiredFields();
		}, 1);
	}
};

export const setFieldListeners = (values, key) => {
	const field = $(`#${key}`);
	if (field) {
		mapKeys(values, (value, key) => {
			field[key.toLowerCase()] = value;
		});
	}
};

export const setInputsMask = () => {
	if ($("#type_company").checked) {
		VMasker($("#cnpj")).maskPattern("99.999.999/9999-99");
	} else {
		VMasker($("#cpf")).maskPattern("999.999.999-99");
		VMasker($("#register_birth")).maskPattern("99/99/9999");
	}

	VMasker($("#phone1")).maskPattern("(99) 99999-9999");
 	var tel2Mask = ['(99) 9999-99999', '(99) 99999-9999'];
	var tel2 = document.querySelector('#phone2');
	VMasker(tel2).maskPattern(tel2Mask[0]);
	tel2.addEventListener('input', inputHandler.bind(undefined, tel2Mask, 14), false);
	setCepMask();
};

function inputHandler(masks, max, event) {
	var c = event.target;
	var v = c.value.replace(/\D/g, '');
	var m = c.value.length > max ? 1 : 0;
	VMasker(c).unMask();
	VMasker(c).maskPattern(masks[m]);
	c.value = VMasker.toPattern(v, masks[m]);
}

export const setCepMask = () => {
	if ($("#register_cep") !== null) {
		VMasker($("#register_cep")).maskPattern("99999-999");
	}

	const addressNumber = $("#addressNumber");
	if (addressNumber !== null) {
		const addressNumberValue = addressNumber.value;
		VMasker($("#addressNumber")).maskPattern("999999");
		addressNumber.value = addressNumberValue;
	}
};

export const setNotRequiredFields = () => {
	if ($("#type_person").checked) {
		mapKeys(companyFields, notRequired);
	} else {
		mapKeys(personFields, notRequired);
	}
};

export const notRequired = (values, key) => {
	if ($(`#${key}`)) {
		$(`#${key}`).required = false;
		$(`#${key}`)["aria-required"] = false;
	}
};
